// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Caml_int32 = require("rescript/lib/js/caml_int32.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_format = require("rescript/lib/js/caml_format.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var Querystringify = require("querystringify");
var JsxRuntime = require("react/jsx-runtime");
var RescriptReactRouter = require("@rescript/react/src/RescriptReactRouter.res.js");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");
var Ticket$ReactHooksTemplate = require("./ticket.res.js");
var Filters$ReactHooksTemplate = require("../dashboard/filters/filters.res.js");
var SearchForm$ReactHooksTemplate = require("../surveys/SearchForm.res.js");
var TicketView$ReactHooksTemplate = require("./TicketView.res.js");
var DomainModel$ReactHooksTemplate = require("../settings/domainModel.res.js");
var AuthProvider$ReactHooksTemplate = require("../AuthProvider.res.js");
var TicketCategory$ReactHooksTemplate = require("./ticketCategory.res.js");
var TicketStatusColors$ReactHooksTemplate = require("./TicketStatusColors.res.js");

function statusFromString(status) {
  var match = status.toLowerCase();
  switch (match) {
    case "closed" :
        return "Closed";
    case "open" :
        return "Open";
    case "parked" :
        return "Parked";
    case "resolved" :
        return "Resolved";
    default:
      return "All";
  }
}

function statusToString(x) {
  switch (x) {
    case "All" :
        return "all";
    case "Open" :
        return "open";
    case "Parked" :
        return "parked";
    case "Resolved" :
        return "resolved";
    case "Closed" :
        return "closed";
    
  }
}

function totalRecord(x) {
  if (x !== undefined) {
    return x;
  } else {
    return "1";
  }
}

function page(x) {
  if (x !== undefined) {
    return x;
  } else {
    return "1";
  }
}

function totalPages(total_records, perPage) {
  return Caml_int32.div(total_records - 1 | 0, perPage) + 1 | 0;
}

var searchPlaceholder = "Search by Ticket ID";

function TicketWorker(props) {
  var search = props.search;
  var initialState_status = statusFromString(props.status);
  var initialState = {
    loading: true,
    showFilter: false,
    tickets: /* [] */0,
    ticketId: 0,
    currentPage: "1",
    agents: /* [] */0,
    assignee: undefined,
    status: initialState_status
  };
  var match = React.useState(function (param) {
        return initialState;
      });
  var setState = match[1];
  var state = match[0];
  var match$1 = React.useContext(AuthProvider$ReactHooksTemplate.authContext);
  var hasPermission = match$1[0];
  var match$2 = React.useState(function (param) {
        
      });
  var setSearchKey = match$2[1];
  var searchKey = match$2[0];
  var queryParams = Querystringify.parse(search);
  var x = Js_dict.get(queryParams, "search");
  var currentSearchKey = x !== undefined && x !== "" ? x : undefined;
  var handleSearch = function (param) {
    if (searchKey !== undefined) {
      return RescriptReactRouter.push("/tickets/work/all?search=" + searchKey);
    } else {
      return RescriptReactRouter.push("/tickets/work/all?");
    }
  };
  var assignTicket = function (ticketId) {
    var assignee = state.assignee;
    if (assignee === undefined) {
      return ;
    }
    var assigneeId = Ticket$ReactHooksTemplate.Assignee.id(assignee);
    var params = {};
    params["assignee_id"] = assigneeId;
    var ticket = Belt_List.keep(state.tickets, (function (xs) {
            return Ticket$ReactHooksTemplate.id(xs) === ticketId;
          }));
    var ticketIds = Belt_List.map(ticket, Ticket$ReactHooksTemplate.id);
    params["ids"] = Json_encode.list((function (prim) {
            return prim;
          }), ticketIds);
    var ticket$1 = {};
    ticket$1["ticket"] = params;
    Js_promise.then_((function (response) {
            console.log(response);
            var updatedTickets = List.map((function (x) {
                    if (Ticket$ReactHooksTemplate.id(x) === ticketId) {
                      return Ticket$ReactHooksTemplate.updateAssignee(state.assignee, x);
                    } else {
                      return x;
                    }
                  }), state.tickets);
            return Promise.resolve(Curry._1(setState, (function (param) {
                              return {
                                      loading: state.loading,
                                      showFilter: state.showFilter,
                                      tickets: updatedTickets,
                                      ticketId: state.ticketId,
                                      currentPage: state.currentPage,
                                      agents: state.agents,
                                      assignee: state.assignee,
                                      status: state.status
                                    };
                            })));
          }), Http$ReactHooksTemplate.fetchPostJSON("/api/v1/tickets/assign", ticket$1));
  };
  var handleAssigneeSelection = function ($$event) {
    var emailText = Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.create, Utils$ReactHooksTemplate.formTargetValue($$event));
    if (Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.isEmpty, emailText)) {
      return Curry._1(setState, (function (param) {
                    return {
                            loading: state.loading,
                            showFilter: state.showFilter,
                            tickets: state.tickets,
                            ticketId: state.ticketId,
                            currentPage: state.currentPage,
                            agents: state.agents,
                            assignee: undefined,
                            status: state.status
                          };
                  }));
    }
    var selected = List.find((function (assignee) {
            return Caml_obj.equal(Ticket$ReactHooksTemplate.Assignee.email(assignee), emailText);
          }), state.agents);
    Curry._1(setState, (function (param) {
            return {
                    loading: state.loading,
                    showFilter: state.showFilter,
                    tickets: state.tickets,
                    ticketId: state.ticketId,
                    currentPage: state.currentPage,
                    agents: state.agents,
                    assignee: selected,
                    status: state.status
                  };
          }));
  };
  var fetchTickets = function (pageNumber) {
    var status = statusToString(state.status);
    var url = Curry._1(hasPermission, "ManageTickets") || Curry._1(hasPermission, "SelfAssignTickets") ? "/api/v1/tickets" : "/api/v1/tickets/assigned";
    var searchParam = currentSearchKey !== undefined ? "&search=" + currentSearchKey : "";
    return Js_promise.then_((function (param) {
                  var x = param[0].get("Page");
                  var page = x !== null ? (
                      x === null ? undefined : Caml_option.some(x)
                    ) : "1";
                  Curry._1(setSearchKey, (function (param) {
                          return currentSearchKey;
                        }));
                  var tickets = Js_promise.then_((function (json) {
                          return Promise.resolve(Json_decode.field("tickets", (function (param) {
                                            return Json_decode.list(Ticket$ReactHooksTemplate.decode, param);
                                          }), json));
                        }), param[1]);
                  return Promise.resolve([
                              tickets,
                              page
                            ]);
                }), Http$ReactHooksTemplate.fetchGetJSONWithHeader(url + "?status=" + status + "&page=" + pageNumber + "&worker_page=true" + searchParam));
  };
  var fetchTicketWorkers = function (param) {
    return Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/recovery_agents", (function (param) {
                  return Json_decode.field("recovery_agents", (function (param) {
                                return Json_decode.list(Ticket$ReactHooksTemplate.Assignee.decode, param);
                              }), param);
                }));
  };
  var domElement = React.useRef(null);
  var handleScroll = function (param) {
    var element = Belt_Option.getExn(Caml_option.nullable_to_opt(domElement.current));
    var bottom = element.scrollHeight - element.scrollTop - element.clientHeight < 5.0;
    if (!bottom) {
      return ;
    }
    var page = Caml_format.int_of_string(state.currentPage);
    var pageNumber = String(page + 1 | 0);
    Js_promise.then_((function (param) {
            var page = param[1];
            return Promise.resolve(Js_promise.then_((function (tickets) {
                              var mergedTickets = List.append(state.tickets, tickets);
                              return Promise.resolve(Curry._1(setState, (function (param) {
                                                return {
                                                        loading: false,
                                                        showFilter: false,
                                                        tickets: mergedTickets,
                                                        ticketId: state.ticketId,
                                                        currentPage: page,
                                                        agents: state.agents,
                                                        assignee: state.assignee,
                                                        status: state.status
                                                      };
                                              })));
                            }), param[0]));
          }), fetchTickets(pageNumber));
  };
  var updateTickets = function (ticketId, status) {
    var updatedTickets = List.map((function (x) {
            if (Ticket$ReactHooksTemplate.id(x) === ticketId) {
              return Ticket$ReactHooksTemplate.updateTicketStatus(status, x);
            } else {
              return x;
            }
          }), state.tickets);
    Curry._1(setState, (function (param) {
            return {
                    loading: state.loading,
                    showFilter: state.showFilter,
                    tickets: updatedTickets,
                    ticketId: state.ticketId,
                    currentPage: state.currentPage,
                    agents: state.agents,
                    assignee: state.assignee,
                    status: state.status
                  };
          }));
  };
  React.useEffect((function (param) {
          Curry._1(setState, (function (prev) {
                  return {
                          loading: true,
                          showFilter: prev.showFilter,
                          tickets: /* [] */0,
                          ticketId: prev.ticketId,
                          currentPage: "1",
                          agents: prev.agents,
                          assignee: prev.assignee,
                          status: prev.status
                        };
                }));
          Js_promise.then_((function (param) {
                  var page = param[1];
                  var tickets = param[0];
                  return Promise.resolve(Js_promise.then_((function (agents) {
                                    return Js_promise.then_((function (tickets) {
                                                  var selected = tickets ? Ticket$ReactHooksTemplate.id(tickets.hd) : 0;
                                                  return Promise.resolve(Curry._1(setState, (function (param) {
                                                                    return {
                                                                            loading: false,
                                                                            showFilter: false,
                                                                            tickets: tickets,
                                                                            ticketId: selected,
                                                                            currentPage: page,
                                                                            agents: agents,
                                                                            assignee: state.assignee,
                                                                            status: state.status
                                                                          };
                                                                  })));
                                                }), tickets);
                                  }), fetchTicketWorkers()));
                }), fetchTickets(state.currentPage));
        }), [search]);
  var toggleFilter = function (param) {
    Curry._1(setState, (function (param) {
            return {
                    loading: state.loading,
                    showFilter: !state.showFilter,
                    tickets: state.tickets,
                    ticketId: state.ticketId,
                    currentPage: state.currentPage,
                    agents: state.agents,
                    assignee: state.assignee,
                    status: state.status
                  };
          }));
  };
  var handleStatusChange = function (status, _event) {
    Curry._1(setState, (function (param) {
            return {
                    loading: state.loading,
                    showFilter: state.showFilter,
                    tickets: state.tickets,
                    ticketId: state.ticketId,
                    currentPage: state.currentPage,
                    agents: state.agents,
                    assignee: state.assignee,
                    status: status
                  };
          }));
    var statusParam = statusToString(status);
    RescriptReactRouter.push("/tickets/work/" + statusParam);
    window.location.reload();
  };
  var displayTickets = function (ticket) {
    var isOpenFilter = state.ticketId === Ticket$ReactHooksTemplate.id(ticket);
    var statusColor = TicketStatusColors$ReactHooksTemplate.badgeClass(Ticket$ReactHooksTemplate.status(ticket));
    var match = Ticket$ReactHooksTemplate.assignee(ticket);
    return JsxRuntime.jsxs("div", {
                children: [
                  isOpenFilter ? JsxRuntime.jsx("div", {
                          className: "absolute left-0 top-0 bottom-0 w-1 bg-palatinateblue rounded-l-lg"
                        }) : null,
                  JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx("span", {
                                        children: "#" + String(Ticket$ReactHooksTemplate.id(ticket)),
                                        className: "text-sm font-bold text-gray-900"
                                      }),
                                  JsxRuntime.jsx("div", {
                                        children: Ticket$ReactHooksTemplate.Status.toString(Ticket$ReactHooksTemplate.status(ticket)),
                                        className: "px-2 py-0.5 rounded-full text-xs font-medium border " + statusColor
                                      })
                                ],
                                className: "flex justify-between items-start mb-2"
                              }),
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx("div", {
                                      children: TicketCategory$ReactHooksTemplate.name(Ticket$ReactHooksTemplate.ticketCategory(ticket)),
                                      className: "inline-flex items-center px-2 py-0.5 rounded text-xs font-medium text-white",
                                      style: {
                                        backgroundColor: TicketCategory$ReactHooksTemplate.colorToString(TicketCategory$ReactHooksTemplate.color(Ticket$ReactHooksTemplate.ticketCategory(ticket)))
                                      }
                                    }),
                                className: "mb-2"
                              }),
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx("img", {
                                        className: "h-3 w-3 mr-1.5",
                                        src: Image$ReactHooksTemplate.curvedArrow
                                      }),
                                  JsxRuntime.jsx("span", {
                                        children: Belt_Option.mapWithDefault(Ticket$ReactHooksTemplate.assignee(ticket), "Unassigned", (function (x) {
                                                return Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.show, Ticket$ReactHooksTemplate.Assignee.email(x));
                                              })),
                                        className: match !== undefined ? "text-gray-700 font-medium text-xs" : "text-gray-400 italic text-xs"
                                      })
                                ],
                                className: "flex items-center text-xs text-gray-600 mb-1.5"
                              }),
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx("img", {
                                        className: "h-3 w-3 mr-1.5",
                                        src: Image$ReactHooksTemplate.clockCircle
                                      }),
                                  JsxRuntime.jsx("span", {
                                        children: Ticket$ReactHooksTemplate.createdAt(ticket).format("MMM DD, h:mm A")
                                      })
                                ],
                                className: "flex items-center text-xs text-gray-500"
                              })
                        ],
                        className: isOpenFilter ? "p-3 pl-4" : "p-3"
                      })
                ],
                className: "mx-3 my-2 rounded-lg border transition-all duration-200 cursor-pointer relative " + (
                  isOpenFilter ? "bg-white border-palatinateblue shadow-md" : "bg-white border-gray-200 hover:border-gray-300 hover:shadow-sm"
                ),
                onClick: (function (param) {
                    var id = Ticket$ReactHooksTemplate.id(ticket);
                    Curry._1(setState, (function (param) {
                            return {
                                    loading: state.loading,
                                    showFilter: state.showFilter,
                                    tickets: state.tickets,
                                    ticketId: id,
                                    currentPage: state.currentPage,
                                    agents: state.agents,
                                    assignee: state.assignee,
                                    status: state.status
                                  };
                          }));
                  })
              }, String(Ticket$ReactHooksTemplate.id(ticket)));
  };
  var displaySelectedTicket = function (ticket) {
    var isOpenFilter = state.ticketId === Ticket$ReactHooksTemplate.id(ticket);
    return JsxRuntime.jsx("div", {
                children: isOpenFilter ? JsxRuntime.jsx(TicketView$ReactHooksTemplate.make, {
                        ticket: ticket,
                        updateTickets: updateTickets,
                        handleAssigneeSelection: handleAssigneeSelection,
                        assignTicket: assignTicket,
                        agents: state.agents
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                className: "flex flex-col 1/2"
              }, String(Ticket$ReactHooksTemplate.id(ticket)));
  };
  var onApply = function (param) {
    Curry._1(setState, (function (param) {
            return {
                    loading: true,
                    showFilter: false,
                    tickets: state.tickets,
                    ticketId: state.ticketId,
                    currentPage: state.currentPage,
                    agents: state.agents,
                    assignee: state.assignee,
                    status: state.status
                  };
          }));
    var pageNumber = state.currentPage;
    Js_promise.then_((function (param) {
            var page = param[1];
            return Js_promise.then_((function (tickets) {
                          return Promise.resolve(Curry._1(setState, (function (param) {
                                            return {
                                                    loading: false,
                                                    showFilter: false,
                                                    tickets: tickets,
                                                    ticketId: state.ticketId,
                                                    currentPage: page,
                                                    agents: state.agents,
                                                    assignee: state.assignee,
                                                    status: state.status
                                                  };
                                          })));
                        }), param[0]);
          }), fetchTickets(pageNumber));
  };
  if (state.loading) {
    return JsxRuntime.jsx("div", {
                children: JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              className: "animate-spin rounded-full h-16 w-16 border-b-2 border-palatinateblue mx-auto mb-4"
                            }),
                        JsxRuntime.jsx("p", {
                              children: "Loading tickets...",
                              className: "text-gray-600 text-lg font-medium"
                            })
                      ],
                      className: "text-center"
                    }),
                className: "flex items-center justify-center h-screen"
              });
  } else {
    return JsxRuntime.jsxs(JsxRuntime.Fragment, {
                children: [
                  state.showFilter ? JsxRuntime.jsx(Filters$ReactHooksTemplate.make, {
                          onClose: (function (param) {
                              toggleFilter();
                            }),
                          onApply: onApply,
                          showDateFilter: false,
                          showFilterPills: false
                        }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                  JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("h1", {
                                              children: "Tickets",
                                              className: "text-lg font-semibold text-gray-900"
                                            }),
                                        JsxRuntime.jsxs("button", {
                                              children: [
                                                JsxRuntime.jsx("img", {
                                                      className: "h-3.5 w-3.5 mr-1.5",
                                                      src: Image$ReactHooksTemplate.filterButton
                                                    }),
                                                "Filters"
                                              ],
                                              className: "bg-white text-gray-700 border border-gray-300 hover:bg-gray-50\n                  hover:border-gray-400 flex items-center rounded py-1.5 px-3 text-xs font-medium\n                  transition-all duration-200",
                                              id: "filters",
                                              onClick: (function (param) {
                                                  toggleFilter();
                                                })
                                            })
                                      ],
                                      className: "px-6 py-3 flex justify-between items-center"
                                    }),
                                className: "bg-white border-b border-gray-200"
                              }),
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsx("div", {
                                                        children: JsxRuntime.jsx(SearchForm$ReactHooksTemplate.make, {
                                                              searchKey: searchKey,
                                                              setSearchKey: setSearchKey,
                                                              handleSearch: handleSearch,
                                                              searchPlaceholder: searchPlaceholder
                                                            }),
                                                        className: "relative mb-3"
                                                      }),
                                                  JsxRuntime.jsxs("div", {
                                                        children: [
                                                          JsxRuntime.jsx("button", {
                                                                children: "All",
                                                                className: "px-2 py-1 rounded-full text-xs font-medium transition-all duration-200 whitespace-nowrap " + (
                                                                  state.status === "All" ? TicketStatusColors$ReactHooksTemplate.filterAllActiveClass : TicketStatusColors$ReactHooksTemplate.filterInactiveClass
                                                                ),
                                                                onClick: (function (param) {
                                                                    return handleStatusChange("All", param);
                                                                  })
                                                              }),
                                                          JsxRuntime.jsx("button", {
                                                                children: "Open",
                                                                className: "px-2 py-1 rounded-full text-xs font-medium transition-all duration-200 whitespace-nowrap " + (
                                                                  state.status === "Open" ? TicketStatusColors$ReactHooksTemplate.filterActiveClass("Open") : TicketStatusColors$ReactHooksTemplate.filterInactiveClass
                                                                ),
                                                                onClick: (function (param) {
                                                                    return handleStatusChange("Open", param);
                                                                  })
                                                              }),
                                                          JsxRuntime.jsx("button", {
                                                                children: "Parked",
                                                                className: "px-2 py-1 rounded-full text-xs font-medium transition-all duration-200 whitespace-nowrap " + (
                                                                  state.status === "Parked" ? TicketStatusColors$ReactHooksTemplate.filterActiveClass("Parked") : TicketStatusColors$ReactHooksTemplate.filterInactiveClass
                                                                ),
                                                                onClick: (function (param) {
                                                                    return handleStatusChange("Parked", param);
                                                                  })
                                                              }),
                                                          JsxRuntime.jsx("button", {
                                                                children: "Resolved",
                                                                className: "px-2 py-1 rounded-full text-xs font-medium transition-all duration-200 whitespace-nowrap " + (
                                                                  state.status === "Resolved" ? TicketStatusColors$ReactHooksTemplate.filterActiveClass("Resolved") : TicketStatusColors$ReactHooksTemplate.filterInactiveClass
                                                                ),
                                                                onClick: (function (param) {
                                                                    return handleStatusChange("Resolved", param);
                                                                  })
                                                              }),
                                                          JsxRuntime.jsx("button", {
                                                                children: "Closed",
                                                                className: "px-2 py-1 rounded-full text-xs font-medium transition-all duration-200 whitespace-nowrap " + (
                                                                  state.status === "Closed" ? TicketStatusColors$ReactHooksTemplate.filterActiveClass("Closed") : TicketStatusColors$ReactHooksTemplate.filterInactiveClass
                                                                ),
                                                                onClick: (function (param) {
                                                                    return handleStatusChange("Closed", param);
                                                                  })
                                                              })
                                                        ],
                                                        className: "flex gap-1"
                                                      })
                                                ],
                                                className: "p-3 border-b border-gray-200 bg-gray-50"
                                              }),
                                          JsxRuntime.jsx("div", {
                                                children: JsxRuntime.jsx("p", {
                                                      children: String(Belt_List.length(state.tickets)) + " " + (
                                                        state.status === "All" ? "tickets" : statusToString(state.status) + " tickets"
                                                      ),
                                                      className: "text-xs font-medium text-gray-600"
                                                    }),
                                                className: "px-3 py-2 bg-white border-b border-gray-200"
                                              }),
                                          JsxRuntime.jsx("div", {
                                                children: Belt_List.length(state.tickets) === 0 ? JsxRuntime.jsxs("div", {
                                                        children: [
                                                          JsxRuntime.jsx("div", {
                                                                children: JsxRuntime.jsx("img", {
                                                                      className: "h-12 w-12 opacity-50",
                                                                      src: Image$ReactHooksTemplate.workOnTickets
                                                                    }),
                                                                className: "bg-gray-100 rounded-full p-4 mb-3"
                                                              }),
                                                          JsxRuntime.jsx("h3", {
                                                                children: "No tickets found",
                                                                className: "text-sm font-semibold text-gray-900 mb-1"
                                                              }),
                                                          JsxRuntime.jsx("p", {
                                                                children: "No tickets match your filter.",
                                                                className: "text-gray-500 text-xs"
                                                              })
                                                        ],
                                                        className: "flex flex-col items-center justify-center h-full p-6 text-center"
                                                      }) : $$Array.of_list(Belt_List.map(state.tickets, displayTickets)),
                                                ref: Caml_option.some(domElement),
                                                className: "flex-1 overflow-y-auto",
                                                onScroll: handleScroll
                                              })
                                        ],
                                        className: "w-1/4 flex flex-col bg-white rounded-lg shadow border border-gray-200 overflow-hidden"
                                      }),
                                  JsxRuntime.jsx("div", {
                                        children: Belt_List.length(state.tickets) === 0 || state.ticketId === 0 ? JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsx("div", {
                                                        children: JsxRuntime.jsx("img", {
                                                              className: "h-16 w-16 opacity-60 mx-auto",
                                                              src: Image$ReactHooksTemplate.workOnTickets
                                                            }),
                                                        className: "bg-gray-100 rounded-xl p-6 mb-4"
                                                      }),
                                                  JsxRuntime.jsx("h3", {
                                                        children: "Select a ticket",
                                                        className: "text-lg font-semibold text-gray-900 mb-2"
                                                      }),
                                                  JsxRuntime.jsx("p", {
                                                        children: "Click on a ticket from the list to view details",
                                                        className: "text-gray-500 text-sm max-w-md"
                                                      })
                                                ],
                                                className: "flex flex-col items-center justify-center h-full p-8 text-center"
                                              }) : $$Array.of_list(Belt_List.map(state.tickets, displaySelectedTicket)),
                                        className: "w-3/4 bg-white rounded-lg shadow border border-gray-200 overflow-hidden"
                                      })
                                ],
                                className: "flex gap-4 px-4 pt-4",
                                style: {
                                  height: "calc(100vh - 9rem)"
                                }
                              })
                        ],
                        className: "bg-gray-50 h-screen overflow-hidden"
                      })
                ]
              });
  }
}

var emptyPageInfo = {
  total: "1",
  perPage: "1"
};

var make = TicketWorker;

exports.statusFromString = statusFromString;
exports.statusToString = statusToString;
exports.totalRecord = totalRecord;
exports.page = page;
exports.totalPages = totalPages;
exports.emptyPageInfo = emptyPageInfo;
exports.searchPlaceholder = searchPlaceholder;
exports.make = make;
/* react Not a pure module */
